import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { ChartType } from 'chart.js';

export type ChartData = { value: number; x: string; y: string; };

@Component({
    selector: 'app-chart',
    templateUrl: './chart.component.html',
    styleUrls: ['./chart.component.scss'],
    standalone: false
})
export class ChartComponent implements OnInit, OnChanges {
  @Input()
  public labels: string[];
  @Input()
  public ip: boolean = false;
  @Input()
  public deudaOrMora: boolean = false;
  @Input()
  public data: any;
  @Input()
  public key?;
  @Input()
  public chartType?: ChartType = 'bar';
  @Input()
  public chartLegend?: boolean = true;
  @Input()
  public isLoading?= true;
  @Input()
  public chartOptions = {};
  public updateOptions = {};
  loadInformation: boolean = false;
  public readonly monthMap = {
    "01": $localize`ene`,
    "02": $localize`feb`,
    "03": $localize`mar`,
    "04": $localize`abr`,
    "05": $localize`may`,
    "06": $localize`jun`,
    "07": $localize`jul`,
    "08": $localize`ago`,
    "09": $localize`sep`,
    "10": $localize`oct`,
    "11": $localize`nov`,
    "12": $localize`dic`,
  };


  //public lineChartColors: Color[] = [
  public lineChartColors = [
    {
      borderColor: 'black',
      // backgroundColor: '#a9e5e3',
      backgroundColor: '#ffa8b8',
    },
    {
      borderColor: 'black',
      // backgroundColor: '#a2edce',
      backgroundColor: '#ffc8c3',
    },
    {
      borderColor: 'black',
      // backgroundColor: '#a0d995',
      backgroundColor: '#f7d8c3',
    },
    {
      borderColor: 'black',
      // backgroundColor: '#c5d084',
      backgroundColor: '#fae187',
    },
    {
      borderColor: 'black',
      // backgroundColor: '#fae187',
      backgroundColor: '#c5d084',
    },
    {
      borderColor: 'black',
      // backgroundColor: '#f7d8c3',
      backgroundColor: '#a0d995',
    },
    {
      borderColor: 'black',
      // backgroundColor: '#ffc8c3',
      backgroundColor: '#a2edce',
    },
    {
      borderColor: 'black',
      // backgroundColor: '#ffa8b8',
      backgroundColor: '#a9e5e3',
    }
  ];

  //public lineChartColorsInvert: Color[] = [
  public lineChartColorsInvert = [
    {
      borderColor: 'black',
      backgroundColor: '#a9e5e3',
    },
    {
      borderColor: 'black',
      backgroundColor: '#a2edce',
    },
    {
      borderColor: 'black',
      backgroundColor: '#a0d995',
    },
    {
      borderColor: 'black',
      backgroundColor: '#c5d084',
    },
    {
      borderColor: 'black',
      backgroundColor: '#fae187',
    },
    {
      borderColor: 'black',
      backgroundColor: '#f7d8c3',
    },
    {
      borderColor: 'black',
      backgroundColor: '#ffc8c3',
    },
    {
      borderColor: 'black',
      backgroundColor: '#ffa8b8',
    }
  ];

  //public lineChartColors5: Color[] = [
  public lineChartColors5 = [
    {
      borderColor: 'black',
      backgroundColor: '#ffa8b8',
    },
    {
      borderColor: 'black',
      backgroundColor: '#f7d8c3',
    },
    {
      borderColor: 'black',
      backgroundColor: '#fae187',
    },
    {
      borderColor: 'black',
      backgroundColor: '#a0d995',
    },
    {
      borderColor: 'black',
      backgroundColor: '#a9e5e3',
    }
  ];

  //public lineChartColorsInvert5: Color[] = [
  public lineChartColorsInvert5 = [
    {
      borderColor: 'black',
      backgroundColor: '#a9e5e3',
    },
    {
      borderColor: 'black',
      backgroundColor: '#a0d995',
    },
    {
      borderColor: 'black',
      backgroundColor: '#fae187',
    },
    {
      borderColor: 'black',
      backgroundColor: '#f7d8c3',
    },
    {
      borderColor: 'black',
      backgroundColor: '#ffa8b8',
    }
  ];

  constructor() {
    // Empty Constructor
  }

  ngOnInit(): void {
    this.init();
  }

  ngOnChanges(): void {
    this.init();
  }

  init() {
    this.loadInformation = false;
    this.chartOptions = [];
    const subtitute = (o, s) => {
      const oArr = o.split("-");
      return oArr[0] + " - " + s;
    }
    let newLabels = [];


    for(let l of this.labels){
      const label = l.substring(5);
      if (Object.keys(this.monthMap).indexOf(label) >= 0) {
        newLabels.push(
          subtitute(l, this.monthMap[label])
        );
      } else {
        newLabels.push(l);
      }
    }

    this.labels = newLabels;
    let series = this.data.map(d => this.calculateSeries(d));
    series.forEach(s => {
      s.label = s.label.replaceAll('0-199','1-199');
      s.name = s.name.replaceAll('0-199','1-199');
    });
    this.data[0].label = this.data[0].label.replace('0-199','1-199');
    this.configureGraph(series);
    this.loadInformation = true;
  }

  private configureGraph(series: any) {
    if (this.chartType == 'line') {
      let color;
      if (this.ip) {
        color = this.lineChartColors.map(c => c.backgroundColor);
      } else if (this.deudaOrMora) {
        color = this.lineChartColorsInvert5.map(c => c.backgroundColor);
      } else {
        color = this.lineChartColors5.map(c => c.backgroundColor);
      }

      this.chartOptions = {
        legend: this.chartLegend ? {
          y: 380,
          data: this.data.map(d => d.label),
        } : undefined,
        xAxis: {
          type: 'category',
          data: this.labels,
          boundaryGap: false
        },
        yAxis: {
          type: 'value'
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        series: series,
        color: color
      };
    } else {
      let color;
      if (this.ip) {
        color =
          this.lineChartColors.map( c =>
              c.backgroundColor
            );
      } else if (this.deudaOrMora) {
        color =
          this.lineChartColorsInvert5.map( c =>
              c.backgroundColor
            );
      } else {
        color =
          this.lineChartColors5.map( c =>
              c.backgroundColor
            );
      }
      this.chartOptions = {
        legend: this.chartLegend ? { y: 380, data: this.data.map(d => d.label), } : undefined,
        xAxis: { type: 'category', data: this.labels },
        yAxis: {
          type: 'value'
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        series,
        color: color
      };
    }
  }

  calculateSeries(d) {
    if (this.chartType === 'bar')
      return ({ ...d, type: this.chartType, name: d.label, stack: this.chartType === 'bar', normal: {}, areaStyle: {}, lineStyle: {} })
    else
      return ({ ...d, type: this.chartType, name: d.label, normal: {}, lineStyle: {} })
  }
}
